import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const setAuthToken = (token) => {
  if (token) api.defaults.headers.common.Authorization = `Bearer ${token}`;
  else delete api.defaults.headers.common.Authorization;
};

export default api;

export const STATUS_LABELS = {
  en_attente: "En attente de validation",
  nouvelle: "Nouvelle",
  confirmee: "Confirmée",
  en_preparation: "En préparation",
  planifiee: "Planifiée",
  en_livraison: "En livraison",
  livree: "Livrée",
  refusee: "Refusée",
  annulee: "Annulée",
};

export const STATUS_STYLES = {
  en_attente: "bg-amber-500/15 text-amber-700 border-amber-500/40",
  nouvelle: "bg-secondary/15 text-secondary border-secondary/30",
  confirmee: "bg-blue-500/10 text-blue-700 border-blue-500/30",
  en_preparation: "bg-amber-500/10 text-amber-700 border-amber-500/30",
  planifiee: "bg-primary/10 text-primary border-primary/30",
  en_livraison: "bg-purple-500/10 text-purple-700 border-purple-500/30",
  livree: "bg-primary/15 text-primary border-primary/40",
  refusee: "bg-destructive/10 text-destructive border-destructive/30",
  annulee: "bg-destructive/10 text-destructive border-destructive/30",
};

export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n || 0);

export const SAUCES = ["Blanche", "Rouge", "Gold"];

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};
